import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './lang/zh_cn';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'zh_cn',
  messages: {
    zh_cn: zhCN,
  },
});
export default i18n;
